import getTableRowCss from './styles/getTableRowCss';
import type {
  Props as TabelCellProps,
  default as TableCell,
} from './TableCell';

export type Props = {
  children: Array<React.ReactElement<TabelCellProps, typeof TableCell>>;
} & React.ComponentProps<'tr'>;

const TableRow = (props: Props) => {
  const { children, ...rest } = props;
  return (
    <tr css={getTableRowCss} role="row" {...rest}>
      {children}
    </tr>
  );
};

export default TableRow;
